import { trimAllObjectStrings } from './trimAllObjectStrings'

// this module's exports map directly to GQL operation names

export const createSchool = (variables: object): object =>
  trimAllObjectStrings(variables)
